module.exports = __webpack_public_path__ + "img/sports-icon.f49e5007b05d30f9b2d30d344f64ca67.svg";